import TAGSORT,{taglist} from "../class/tagsortShared";

const [d] = [document];

const REMOTE_ARTICLE_API_ORIGIN = 'https://iwata.websapo.jp';

const itemTemplate =  `
  <div class="case-list" :class="[ 'is-paged-' + paged ]">
    <ul class="case-list__inner">
      <li v-for="(article , ind) in pagedArticles">
        <a :href="article.href" class="case-list__link">
          <figure>
            <img :src="article.thumb" :alt="article.title" class="case-item__img">
          </figure>
          <p class="cat" v-if="article.category.name">{{ article.category.name }}</p>
          <p class="title">{{ article.title }}</p>
          <p class="name">{{ article.desc }}</p>
          <ul class="tags" v-if="article.keywords.length">
            <li v-for="(tag, ind) in article.keywords">#{{ tag }}</li>
          </ul>
        </a>
      </li>
    </ul>
  </div>
  `;

const relatedItemTemplate =  `
  <div class="case-list case-connection-list is-related" v-if="relatedArticles.length">
    <h3 class="case-list__title case-connection-list__title">関連事例</h3>
    <ul class="case-list__inner case-connection-list__inner">
      <li v-for="(article , ind) in relatedArticles">
        <a :href="article.href" class="case-list__link">
          <figure>
            <img :src="article.thumb" :alt="article.title">
          </figure>
          <p class="cat" v-if="article.category.name">{{ article.category.name }}</p>
          <p class="title">{{ article.title }}</p>
          <p class="name">{{ article.desc }}</p>
          <ul class="tags" v-if="article.keywords.length">
            <li v-for="(tag, ind) in article.keywords">#{{ tag }}</li>
          </ul>
        </a>
      </li>
    </ul>
  </div>
  `;


class taglist_custom extends taglist {
  constructor( opt, parent ) {
    super( opt, parent );
  }
  insertContainer ( tag = `<taglist />`) {
    const container = d.querySelector( this.opt.container || '.rwd002-container');
    // const pagination = d.querySelector( this.opt.pagination || '.rwd002-pagination');
    const breadcrumbs = d.querySelector( this.opt.breadcrumbs || '.rwd002-breadcrumbs');
    const is_list = d.body.classList.contains('is--list');
    if( !container ) return false;

    if( is_list ){
      breadcrumbs.insertAdjacentHTML('afterend', tag);
    }
  }
}

const domReady = () => {
  const listContent = d.querySelector('.rwd002-list-content');
  let articlesPerPage = 12; // デフォルト値

  if (listContent) {
    const dataCountPage = listContent.dataset.countPage;
    if (dataCountPage && !isNaN(parseInt(dataCountPage, 10))) {
      articlesPerPage = parseInt(dataCountPage, 10);
    }
  }
  
  const Tagsort = new TAGSORT({
    apiOrigin: REMOTE_ARTICLE_API_ORIGIN,
    list: {
      itemTemplate,
      perpage: articlesPerPage, // 一度に表示する記事数
    },
    taglist: {
      pagination: '.rwd002-pagination', // taglistを表示する基準の要素
    },
    related: {
      container: '.rwd002-pagination',
      itemTemplate: relatedItemTemplate,
      amount: '3',
    }
  });

  d.addEventListener('tagsort.beforeInit', e => {
    const TAGSORT = e.detail;
    Tagsort.taglist = new taglist_custom( TAGSORT.opt.taglist, TAGSORT );
  });

  Tagsort.render();
};

export default function CASE () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
}